import React, { PureComponent } from "react";
import { Icon } from "semantic-ui-react";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as ArrowIcon } from "../../../../../assets/svg/chevron.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import NoData from "../NoData/NoData";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import ChartIndexSelector from "../ChartsOptionsSidebar/ChartIndexSelector";
import ShareOfVoiceNewsChart from "./ShareOfVoiceNewsChart";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";
class ShareOfVoiceNews extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            // downloading: false,
            showAggsDropdown: false,
            topic: "",
            index: 0,
        };

        this.container = React.createRef();
        this.chart = React.createRef();
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "shareOfVoiceNews");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        if (this.props.graph_type === "pie") {
            if (d.options.topicId !== "all") {
                if (d.options.allSubtopicSelected) {
                    newFilter.topics = [d.options.topicId];
                    newFilter.subtopics = [];
                } else {
                    newFilter.topics = [];
                    newFilter.subtopics = d.options.subtopicIds;
                }
            }

            if (d.options.optionType === "others") {
                newFilter.publications = d.options.items.map((i) => i.name.toLowerCase());
            } else {
                newFilter.publications = [d.name.toLowerCase()];
            }
        } else if (this.props.graph_type === "bar") {
            if (d.series.userOptions.topicId !== "all") {
                if (d.series.userOptions.allSubtopicSelected) {
                    newFilter.topics = [d.series.userOptions.topicId];
                    newFilter.subtopics = [];
                } else {
                    newFilter.topics = [];
                    newFilter.subtopics = d.series.userOptions.subtopicIds;
                }
            }

            if (d.series.userOptions.optionType === "others") {
                newFilter.publications = d.series.userOptions.items.map((i) => i.name.toLowerCase());
            } else {
                newFilter.publications = [d.name.toLowerCase()];
            }
        }
        return newFilter;
    }

    handleContextMenuClick = (d) => {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    getChart = () => {
        let data = JSON.parse(JSON.stringify(this.props.data.data[this.state.index]));

        let options = this.props.data.data.map((d, i) => ({ label: d.name, value: i }));

        return (
            <>
                <div className="chart-item-name">
                    <ChartIndexSelector
                        selectorType="Topic"
                        currentName={data.name}
                        currentIndex={this.state.index}
                        options={options}
                        onIndexChange={this.onIndexChange}
                        widgetContainerRef={this.props.widgetContainerRef}
                    />
                </div>
                {data.value > 0 ? (
                    <ShareOfVoiceNewsChart
                        // resizedCount={this.props.resizedCount}
                        widgetContainerRef={this.props.widgetContainerRef}
                        data={data}
                        currentChartType={this.props.graph_type}
                        showGridLines={this.props.showGridLines}
                        showLabel={this.props.showLabel}
                        showLegend={this.props.hideCommonLegend}
                        addContextMenuListener={this.addContextMenuListener}
                        expandWidget={this.props.expandWidget}
                    />
                ) : (
                    <NoData />
                )}
            </>
        );
    };

    onIndexChange = (index) => this.setState({ index });

    increment = () => {
        if (this.props.data.data.length === 1) return;
        let index = (this.state.index + 1) % this.props.data.data.length;
        this.setState({ index });
    };

    decrement = () => {
        if (this.props.data.data.length === 1) return;
        let index = this.state.index;
        if (index === 0) index = this.props.data.data.length - 1;
        else index--;
        this.setState({ index });
    };

    renderDownloadButton = (nodata) => {
        if (!nodata && this.props.data.data) {
            if (this.props.data.data[this.state.index].value === 0) nodata = true;
        }

        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        return html2canvas(this.chart.current, { backgroundColor: options.background ? "#fff" : null }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [["Topic", "Publication", "Value"]];
        let topic = this.props.data.data[this.state.index];
        topic.csvData.forEach((subtopic) => {
            csvFmt.push([topic.name, subtopic.pub, subtopic.value]);
        });
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="This chart provides Share of Voice for the news topics you have selected in the filters. This chart uses volume of conversations to determine SOV."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        <div className="chart-type">
                            <span onClick={() => this.props.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                <Icon name="pie chart" />
                            </span>
                            <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                <Icon name="bar chart" />
                            </span>
                        </div>
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />}
                        {!nodata && <CustomCheckBox checked={this.props.hideCommonLegend} onClick={this.props.changehideCommonLegend} label="Show Legends" />}
                        {this.props.graph_type === "bar" && (
                            <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart dashboard-chart-slider" ref={this.container}>
                        <div
                            className={`chart-slider chart-slider-left ${this.props.data.data.length === 1 ? "disabled" : ""}`}
                            data-html2canvas-ignore
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                        <div className="chart-area" ref={this.chart}>
                            {this.getChart()}
                        </div>
                        <div
                            className={`chart-slider chart-slider-right ${this.props.data.data.length === 1 ? "disabled" : ""}`}
                            data-html2canvas-ignore
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareOfVoiceNews);
